import React, { useState } from "react";

const Search = React.forwardRef((props, ref) => {
    const [input_value, SetValue] = useState("");
    let style = {};
    if (props.style !== undefined) style = props.style;
    return (
        <div className="avaliador-search-column">
            {props.children ? props.children : ''}
            <div className={'avaliador-search-box ' + (props.className || '')} style={{ ...style }}>
                <i className="mdi mdi-magnify"></i>
                <input ref={ref} placeholder={props.placeholder} value={input_value} className="avaliador-search-input" onChange={(e) => { SetValue(e.target.value); if (!props.WaitConfirm) (props.ValueChange && props.ValueChange(e.target.value)); }} />
                <button type="button" className="avaliador-search-button" onClick={() => (props.ValueChange && props.ValueChange(input_value))}>{props.buttonText || 'Buscar'}</button>
            </div>
        </div>
    );
});
export default Search;
